export default "__VITE_ASSET__2a3199ad__"